<template>
    <div class="jbmzlsq">
        <div class="massage-box" v-show="!showSuccess">
            <input type="number" class="clientMobile" placeholder="请输入手机号码" v-model.trim="clientMobile" />
            <div class="verify">
                <input type="text" class="code" placeholder="请输入验证码" v-model.trim="code" />
                <span class="verifyButton" @click="sendCode">{{ verifyMsg }}</span>
            </div>
            <img src="./button.png" alt="" class="button"  @click="submit">
        </div>
        <div v-show="showSuccess" class="successHtml">
            <img src="./successHtml.png" alt="" class="button">
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import ajax from "@/common/ajax/ajax"
    import { Toast } from 'vant'
    export default {
        data () {
            return {
                showSuccess: false,
                showCuntDown: false,
                showAlert: false,
                showSuccess: false,
                verifyMsg: '验证码',
                alertMessage: '',
                clientMobile: '',
                code: '',
                wait: 30,
                proID: ''
            }
        },
        components: { alert },
        created() {
            this.getAppParams()
        },
        methods: {
            getAppParams(){
                let url = window.location.href //获取url中"?"符后的字串
                const index=url.lastIndexOf("\?")
                const urlSplice =  url.substring(index+1,url.length)
                console.log(urlSplice,'urlSplice')
                const strs = urlSplice.split("&") //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
                const obj ={}
                strs.map(el=>{
                    const indexEl=el.lastIndexOf("\=")
                    const urlSpliceEl =  el.substring(indexEl+1,el.length)
                    const urlSpliceElKey =  el.substring(0,indexEl)
                    const objKeyValue = urlSpliceEl
                    const objKey = urlSpliceElKey
                    if(objKey === 'proID'){
                        this.proID = objKeyValue
                        console.log(this.proID, 'this.proID')
                    }
                })
                console.log(strs,'strs')
            },
            sendCode() {
                if (this.verifyMsg !== '验证码') {
                    return
                }
                var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ //11位手机号码正则
                if (!reg_tel.test(this.clientMobile)) {
                    Toast('请输入正确的手机号码')
                    return
                }
                const senddata = {
                    mobile: this.clientMobile,
                    type: 1105,
                }
                const vm = this
                function time() {
                    if (vm.wait === 0) {
                            vm.verifyMsg = '验证码'
                            vm.wait = 30
                    } else {
                            vm.verifyMsg = vm.wait + '秒后重新发送'
                            vm.wait--
                            setTimeout(function () {
                                time()
                            }, 1000)
                    }
                }
                time()
                ajax.sendVerifyCode(senddata).then((data) => {
                    Toast(data.data.resultMessage)
                    }).catch((err) => {
                        Toast('获取验证码失败')
                    })
            },
            submit() {
                var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ //11位手机号码正则
                if (!reg_tel.test(this.clientMobile)) {
                    Toast('请输入正确的手机号码')
                    return
                }
                if (!this.code) {
                    Toast('验证码不能为空')
                    return
                }
                ajax.application(this.clientMobile, this.proID, this.code).then((data) => {
                    console.log(data, '请求成功的data')
                    if(data.data.resultStatus === '0') {
                        // 请求成功
                        this.showSuccess = true
                        this.clientMobile = ''
                        this.code = ''
                    }
                    if(data.data.resultStatus !== '0') {
                        Toast(data.data.resultMessage)
                    }
                }).catch((err) => {
                    Toast('申领失败')
                })
            }
        }
    }
</script>
<style scoped>
    .jbmzlsq {
        height: 100vh;
        width: 100vw;
        background: url("./bg.png") no-repeat;
        overflow: auto;
        background-size: 100% 100%;
        padding: 20px 0;  
        overflow: hidden;
    }
    .massage-box {
        height: 50%;
        width: 100%;
        margin: 0 auto;
        padding: 20% 20px 0px 20px;
        background: url("./message-bg.png") no-repeat;
        overflow: auto;
        text-align: center;
        background-size: 100% 100%;
        position: absolute;
        top: 38%;
    }
    input {
        width: 80%;
        height: 40px;
        line-height: 40px;
        color: #323232;
        font-size: 14px;
        margin-bottom: 25px;
        border: 1px solid #fff;
    }
    ::-webkit-input-placeholder {
        padding-left: 15px;
    }
    .verify {
        margin-bottom: 25px;
    }
    .verify input{
        width: 40%;
        margin-bottom: 0px;
    }
    .verifyButton {
        display: inline-block;
        width: 35%;
        line-height: 40px;
        background-color: #4884df;
        margin-left: 10px;
        font-size: 12px;
        color: white;
    }
    .button {
        width: 80%;
        height: 40px;
    }
    .successHtml {
        position: absolute;
        top: 40%;
    }
    .successHtml img {
        width: 100%;
        height: 50%;
    }
</style>



// WEBPACK FOOTER //
// index.vue?3a85c310